import { forwardRef } from "react";
import * as React from "react";

type IconTriangleProps = React.ComponentProps<"svg"> & {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
};

export const IconTriangle = forwardRef<SVGSVGElement, IconTriangleProps>(
  (props, ref) => {
    return (
      <svg
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path d="M0 8L7 0L14 8L0 8Z" fill="#1E1E1E" />
      </svg>
    );
  },
);

IconTriangle.displayName = "IconTriangle";
